module.exports = __webpack_public_path__ + "img/Chat.449f3314.png";